import PropTypes from 'prop-types'
import React, {useState} from 'react'
import i18n from 'i18next'
import {HeaderRow} from '#components/m/HeaderRow'
import {FeedbackRowAsAzubi} from '#components/m/Feedback/FeedbackRowAsAzubi'
import {FeedbackRowAsAusbilder} from '#components/m/Feedback/FeedbackRowAsAusbilder'
import {FeedbackRowAsFachausbilder} from '#components/m/Feedback/FeedbackRowAsFachausbilder'
import Api from '#services/api'
import {useCurrentUserRole} from '#hooks/store/useCurrentUserRole'
import Pagination from '#components/m/Pagination'
import {useSelector} from 'react-redux'
import Text from '#components/a/Text'

const headerOptionsAzubi = [
  {displayName: i18n.t('option_filename')},
  {displayName: i18n.t('option_author')},
  {displayName: i18n.t('option_date')},
  {displayName: ''},
]

const headerOptionsAusbilder = [
  {displayName: i18n.t('option_filename')},
  {displayName: i18n.t('option_author')},
  {displayName: i18n.t('option_date')},
  {displayName: i18n.t('option_feedback_type')},
  {displayName: i18n.t('option_concerning_azubi')},
  {displayName: ''},
]

const headerOptionsFachausbilder = [
  {displayName: i18n.t('option_concerning_azubi_evaluated')},
  {displayName: i18n.t('option_filename')},
  {displayName: i18n.t('option_date')},
  {displayName: ''},
]

const getDownloadFileFunction = feedback => async () => {
  await Api.getFeedbackFile(feedback.id, feedback.originalFilename)
}

function FeedbackTable({feedbackList}) {
  const role = useCurrentUserRole()

  const getFeedbackRow = feedback => {
    if (role.isAzubi)
      return (
        <FeedbackRowAsAzubi feedback={feedback} key={feedback.id} downloadFile={getDownloadFileFunction(feedback)} />
      )
    if (role.isAusbilder)
      return (
        <FeedbackRowAsAusbilder
          feedback={feedback}
          key={feedback.id}
          downloadFile={getDownloadFileFunction(feedback)}
        />
      )
    if (role.isFachausbilder)
      return (
        <FeedbackRowAsFachausbilder
          feedback={feedback}
          key={feedback.id}
          downloadFile={getDownloadFileFunction(feedback)}
        />
      )
    return null
  }

  const getFeedbackHeaderOptions = () => {
    if (role.isAzubi) return headerOptionsAzubi
    if (role.isAusbilder) return headerOptionsAusbilder
    if (role.isFachausbilder) return headerOptionsFachausbilder
    return null
  }

  const tableClassName = `feedback--table feedback--table-${role.role}`

  const matchingAzubiIds = useSelector(state => state.filter.matchingAzubiIds)
  const filteredFeedbackList = role.isAzubi
    ? feedbackList
    : feedbackList.filter(feedback => {
        if (matchingAzubiIds.includes(feedback.author?.id)) {
          return true
        } else if (matchingAzubiIds.includes(feedback.concerningAzubi?.id)) {
          return true
        }
        return false
      })

  const [visibleFeedbackList, setVisibleFeedbackList] = useState([])
  const scroll = (skip, take) => {
    setVisibleFeedbackList(filteredFeedbackList.slice(skip, skip + take))
  }

  if (filteredFeedbackList?.length === 0) {
    return <Text text={i18n.t('no_feedback')} />
  }

  return (
    <>
      <Pagination data={filteredFeedbackList} scrollCallback={scroll} />
      <table className={tableClassName}>
        <thead>
          <tr>
            <HeaderRow headerOptions={getFeedbackHeaderOptions()} />
          </tr>
        </thead>
        <tbody>{visibleFeedbackList.map(feedback => getFeedbackRow(feedback))}</tbody>
      </table>
    </>
  )
}

FeedbackTable.propTypes = {
  feedbackList: PropTypes.array,
}

export default FeedbackTable
